export class ClientCampaignBuild {
  CampaignId :number;
  ClientName: string;
  MessageType: string;
  BulkBuild: boolean;
}
